import { getStorage, setStorage } from "@/storage";
export const mixinTable = {
  data() {
    return {
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
      //常量
      education_: [],
      grade_: [],
      job_type_: [],
      nature_: [],
      scale_: [],
      welfare_: [],
      work_age_: [],
      areaArr_: [],
      categoryArr: [],
      majorArr: [],
      activeJob_: [],
      school_: [],
      addressArr_: [],
      schooltype_: [
        { label: '985', value: 1 },
        { label: '211', value: 2 },
        { label: '双一流', value: 3 },
        { label: '其他', value: 4 },
      ],
      ageTypeOptions_:[
        { label: '20岁以内', value: 1 },
        { label: '20-29岁', value: 2 },
        { label: '30-39岁', value: 3 },
        { label: '40-49岁', value: 4 },
        { label: '50岁及以上', value: 5 },
      ],
      companyInfo: null,
    }
  },
  methods: {
    handleSearch() {
      this.table.params.page = 1;
      this.table.data = [];
      this.getTable();
    },
    // 切换状态
    handleTabs() {
      this.table.params.page = 1;
      this.table.data = [];
      this.getTable();
    },
    // pageSize 改变时会触发
    handleSizeChange(pageSize) {
      this.table.params.count = pageSize;
      this.table.params.page = 1;
      this.getTable();
    },
    //页面改变时触发
    handleCurrentChange(page) {
      this.table.params.page = page;
      this.getTable();
    },
    // 字段转义
    toStr(data, key) {
      return data[key] || ''
    },
    //行业类型枚举
    getIndustry() {
      this.$http.post("/common/param/industry", {}).then(res => {
        if (res.code == 1) {
          this.industryOpt = res.data;
        } else {
          this.$message.error(res.msg);
        }
      })
    },
    getParamsJob() {

      this.$http.post("/common/param/job", { type: 'date_type|education|work_age|job_type|nature|scale|welfare' }).then(res => {
        if (res.code == 1) {
          let info = res.data;
          this.education_ = info.education
          this.grade_ = info.grade
          this.job_type_ = info.job_type
          this.nature_ = info.nature
          this.scale_ = info.scale
          this.welfare_ = info.welfare
          this.work_age_ = info.work_age
        } else {
          this.$message.error(res.msg);
        }
      })
    },
    //省市区
    getDistrictAll() {
      this.$http.get('/common/district/all', { params: {} }).then(res => {
        if (res.code == 1) {
          this.areaArr_ = res.data.list;
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    // 获取岗位类别
    getCategory() {
      this.$http.get("common/param/category", { params: {} }).then((res) => {
        if (res.code == 1) {
          this.categoryArr = res.data;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    // 获取专业类型
    getMajor() {
      this.$http
        .get("/common/college/getMajor", { params: { page: 1, count: 10000 } })
        .then((res) => {
          if (res.code == 1) {
            this.majorArr = res.data.list;
            let str = { id: 0, name: "不限" };
            this.majorArr.unshift(str);
          } else {
            this.$message.error(res.msg);
          }
        });
    },
    maskPhoneNumber(phone) {
      // 校验是否为11位数字
      if (!/^\d{11}$/.test(phone)) {
        return phone; // 如果不是11位数字则原样返回
      }
      return phone.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2');
    },
    //获取本公司正在上架的岗位
    getActiveJob() {
      let _params = {
        page: 1,
        count: 10000,
        status: 1,
      }
      this.$http
        .get("/company/job/webList", { params: _params })
        .then((res) => {
          if (res.code === 1) {
            this.activeJob_ = res.data.list;
          } else {
            this.$message.error(res.msg);
          }
        });
    },
    getSchool(query) {
      let _params = {
        page: 1,
        count: 10000,
        name: query,
      };
      if (query) {
        this.$http
          .get("/common/college/list", { params: _params })
          .then((res) => {
            if (res.code === 1) {
              this.school_ = res.data.list;
            } else {
              this.$message.error(res.msg);
            }
          });
      } else {
        this.school_ = []
      }

    },
    getaddresslist() {
      let params = {
        page: 1,
        count: 10000,
      };
      this.$http
        .get("/company/address/list", { params: params }).then(res => {
          if (res.code == 1) {
            this.addressArr_ = res.data.list;
          } else {
            this.$message.error(res.msg)
          }
        })
    },
    GetDetail_() {
      this.$http.post("/company/company/index", {}).then((res) => {
        if (res.code == 1) {
          let info = res.data;
          this.companyInfo = info;
          setStorage("info", info);
          setStorage("name", info.name);
          setStorage("use_earnest", info.use_earnest);
          setStorage("balance", info.balance);
          setStorage("xy_code", info.xy_code);
          setStorage("pass_at", info.pass_at);
          setStorage("auth_status", info.auth_status);
          setStorage("apply_info", info.apply_info);
          this.$forceUpdate();
        }
      });
    },
    //工商信息认证是待审核和已拒绝的情况，若点击发布岗位或查看/下载新的简历,不可以
    //企业正在退保申请中，如果创建岗位、查看和下载新的简历要提示：很抱歉，您已申请退保，暂不支持使用该功能
  },
  computed: {
    isRefoundBzj_() {
      // 判断是否在退保中
      return Object.keys(getStorage("apply_info")).length > 0
      //apply_info有值就是在退保证金申请中，
    },
    //待审核和已拒绝的情况
    isAuditOrRefuse() {
      // 判断工商信息是否在审核中或者已拒绝
      return getStorage("auth_status") == 2 || getStorage("auth_status") == 4
    }
  }
}